import React from 'react';
import './ADd.css'
import { useEffect } from 'react';
import { useState } from 'react';
import { Card } from 'react-bootstrap';
import useAuth from '../Login/useAuth';
import bg from '../../img/gettyimages-1194458449.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';
const AddYourMobile = () => {
    const { user, loading } = useAuth()
    const [yourMobile, setYourMobile] = useState([])
    useEffect(() => {
        fetch('https://thawing-ridge-28572.herokuapp.com/usermobile')
            .then(res => res.json())
            .then(data => setYourMobile(data))
    }, [])
    const appointmentBanner = {
        background: `url(${bg})`,
        backgroundColor: 'rgba(45, 58, 74, 0.9)',
        backgroundBlendMode: 'soft-light',
     
        height: '100%',
        backgroundPosition: 'center',
        backgroundRepeat: ' no-repeat',
        backgroundSize: 'cover',

    }
    AOS.init();

    return (
        <div className='ba' style={appointmentBanner}>
            <h3 className='text-white'>Your Name <em className='text-primary fs-3'>
                {user?.displayName}
            </em> And Your Email <em className='text-primary fs-3'>
                    {user?.email}
                </em> </h3>
           <div className="row">
                {
                    yourMobile.map(y =>
                        <div className="col-md-6 d-flex align-items-center justify-content-center">
                            <Card
                            data-aos="fade-down"
                            data-aos-easing="linear"
                            data-aos-duration="2500"
                            className='cards' style={{ width: '15rem' }}>
                                <Card.Img variant="top" src={y.image} />
                                <Card.Body>
                                    <Card.Title className='text-capitalize text-start fs-4'>Mobile Name{y.name}</Card.Title>
                                    <Card.Text className='text-capitalize text-start fs-4'>
                                        Price: ${y.price}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    )
                }
            </div>
            {loading && <div>
                <div class="spinner-grow text-dark" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div><div class="spinner-grow text-dark" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>}
        </div>
    );
};

export default AddYourMobile;